<script>
    import ItemSelection from '../lib/ItemSelection.svelte';
    import Select from 'svelte-select';
    import { refresh } from './libs';
    import { toast } from '@zerodevx/svelte-toast';

    export let api, selected, admin = false;
    let imgbb_key = '4bce902749d05715d5bdc6888f66fbb3';
    
    function sleep(s) {
        return new Promise(resolve => setTimeout(resolve, (s * 1000)));
    };

    const toBinary = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.replace('data:image/png;base64,', ''));
        reader.onerror = error => reject(error);
    });

    async function imageupload(e) {
        toast.push('Uploading image...');
        
        let formdata = new FormData();
        formdata.append('image', await toBinary(e.target.files[0]));
        formdata.append('name', e.target.files[0].name);

        let imgbb = await fetch('https://api.imgbb.com/1/upload?key=' + imgbb_key, {
            method: 'POST',
            body: formdata
        }).then(res => {return res.json()});
        
        toast.push('Uploaded image!', {
            'classes': ['success']
        });
        return imgbb.data.url;
    };

    // Searching

    let searchinp = '', searchitems;
    function search() {
        let items = searchitems.children;
        for (const a of items) {
            if (a.getAttribute('data-search') == 'show' || a.children[1].innerHTML.toUpperCase().indexOf(searchinp.toUpperCase()) > -1) {
                a.classList.remove('hidden');
            } else {
                a.classList.add('hidden');
            }
        };
    };
</script>

<!-- <div class="relative flex flex-row items-center justify-start w-full h-full overflow-x-hidden">
    <div class="z-40 flex flex-col items-center justify-start w-full h-full max-h-full overflow-y-auto bg-white">
        {#each shops as shop, i}
            <div class="flex flex-row items-center justify-start w-full p-2 cursor-pointer select-none hover:bg-gray-200" on:click={() => {document.getElementById('shop-editor').classList.remove('translate-x-full'); selected = shop}}>
                <img src="{shop.ShopImage}" alt="{shop.ShopName} Cover Image" class="w-24 h-12 mr-3">
                <h2 class="flex-1 mr-3 text-xl text-left">{shop.ShopName}</h2>
                <img src="/assets/icon/arrow.svg" alt="Arrow" class="h-12 transform rotate-90">
            </div>
        {:else}
            <p>Loading...</p>
        {/each}
    </div>
    
    <div id="shop-editor" class="absolute top-0 left-0 z-50 grid w-full h-full grid-cols-2 gap-5 px-12 py-5 overflow-auto transition-all duration-1000 ease-in-out transform translate-x-full bg-white">
        <img src="/assets/icon/cross.svg" alt="Close" class="absolute top-0 left-0 w-8 h-8 transform -rotate-90 cursor-pointer select-none" on:click={() => document.getElementById('shop-editor').classList.add('translate-x-full')}>
    
        <div class="flex flex-col items-center justify-end">
            <p class="w-full text-left">Shop Name</p>
            <input bind:value={selected.ShopName}>
        </div>
        {#if admin == true}
            <div class="flex flex-col items-center justify-between row-span-3">
                <PlayerSelection bind:mcs={selected.ShopOwner} bind:discs={selected.ShopOwnerD}></PlayerSelection>
            </div>
        {:else}
            <div class="flex flex-col items-center justify-between">
                <p class="w-full text-left">Shop Owners</p>
                <p class="w-full text-sm italic text-left">Please DM <a href="https://discordapp.com/users/349062232652382220" class="text-blue-700 hover:underline">@IzMichael#6437</a> to update a shop's owner list.</p>
                <input bind:value={selected.ShopOwner} disabled class="cursor-not-allowed">
            </div>
        {/if}
        <div class="flex flex-col items-center justify-between">
            <p class="w-full text-left">Shop Location</p>
            <input bind:value={selected.ShopLocation}>
        </div>
        <div class="flex flex-col items-center justify-between">
            <p class="w-full text-left">Shop Coordinates</p>
            <div class="flex flex-row items-center justify-between w-full">
                <input placeholder="X" bind:value={selected.ShopCoordinates[0]}>
                <input placeholder="Y" bind:value={selected.ShopCoordinates[1]}>
                <input placeholder="Z" bind:value={selected.ShopCoordinates[2]}>
            </div>
        </div>
        <div class="col-span-2"> 
            <ItemSelection bind:selecteditems={selected.ShopProducts}></ItemSelection>
        </div>
        
        <div class="flex flex-col items-center justify-between">
            <p class="w-full text-left">Shop Cover Image</p>
            <label for="coverupload" class="flex flex-row items-center justify-start w-full p-2 border border-black outline-none cursor-pointer select-none hover:bg-gray-200 group">
                <img src="{selected.ShopImage}" alt="Cover" class="h-12 mr-2">
                <p class="font-bold group-hover:text-gray-800">Upload New Image</p>
                <input id="shopcoverupload" class="hidden" type="file" on:change={async e => selected.ShopImage = await imageupload(e)}>
            </label>
        </div>
        <div class="flex flex-col items-center justify-between">
            <p class="w-full text-left">Shop Logo</p>
            <label for="logoupload" class="flex flex-row items-center justify-start w-full p-2 border border-black outline-none cursor-pointer select-none hover:bg-gray-200 group">
                <img src="{selected.ShopLogo}" alt="Logo" class="h-12 mr-2">
                <p class="font-bold group-hover:text-gray-800">Upload New Image</p>
                <input id="shoplogoupload" class="hidden" type="file" on:change={async e => selected.ShopLogo = await imageupload(e)}>
            </label>
        </div>

        <button on:click={async () => {
            await fetch('https://api.phoenix-pages.izmichael.com/shops/' + selected._id, {
                headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8', 'Content-Type': 'application/json' },
                method: 'PUT',
                body: JSON.stringify(selected)
            });
            document.getElementById('shop-editor').classList.add('translate-x-full');
            await sleep(1.1);
            window.location = window.location;
        }} class="w-full col-span-2 p-1 font-bold text-white bg-green-500 hover:bg-green-400">Save</button>
    </div>
</div> -->

<div class="flex flex-col items-center justify-center w-full h-full max-h-full overflow-hidden lg:flex-row shadow-elevate-lg rounded-2xl">
    <div id="editor" class="relative z-50 w-full h-full {selected != undefined && selected.ShopName != undefined && selected.ShopName != '' ? 'grid grid-cols-2 p-5' : 'flex flex-col justify-center items-center'} max-h-full overflow-auto gap-5 bg-white basis-2/3 grow shrink-0 shadow-elevate-lg">
        {#if selected != undefined && selected.ShopName != undefined && selected.ShopName != ''}
            <div class="flex flex-col items-center justify-end">
                <p class="w-full text-left">Shop Name</p>
                <input bind:value={selected.ShopName}>
            </div>
            <div class="flex flex-col items-center justify-between">
                <p class="w-full text-left">Shop Owners</p>
                <p class="w-full text-sm italic text-left">Please DM <a href="https://discordapp.com/users/349062232652382220" class="text-blue-700 hover:underline">@IzMichael#6437</a> to update a shop's owner list.</p>
                {#if admin == true}
                    <input bind:value={selected.ShopOwner}>
                {:else}
                    <input bind:value={selected.ShopOwner} disabled class="cursor-not-allowed">
                {/if}
            </div>
            <div class="flex flex-col items-center justify-between">
                <p class="w-full text-left">Shop Location</p>
                <!-- <input bind:value={selected.ShopLocation}> -->
                <Select items={api.places.sort((a, b) => (a.PlaceName.toUpperCase() > b.PlaceName.toUpperCase()) ? 1 : -1)} value={selected.ShopLocation} labelIdentifier="PlaceName" optionIdentifier="PlaceName" containerClasses="w-full outline-none" containerStyles="border-color: #000000; border-radius: 0px; padding: 0.5rem;" on:select={(e) => selected.ShopLocation = e.detail.PlaceName}></Select>
            </div>
            <div class="flex flex-col items-center justify-between">
                <p class="w-full text-left">Shop Coordinates</p>
                <div class="flex flex-row items-center justify-between w-full">
                    <input placeholder="X" type="number" bind:value={selected.ShopCoordinates[0]}>
                    <input placeholder="Y" type="number" bind:value={selected.ShopCoordinates[1]}>
                    <input placeholder="Z" type="number" bind:value={selected.ShopCoordinates[2]}>
                </div>
            </div>
            <div class="col-span-2"> 
                <ItemSelection bind:selecteditems={selected.ShopProducts}></ItemSelection>
            </div>
            
            <div class="flex flex-col items-center justify-between">
                <p class="w-full text-left">Shop Cover Image</p>
                <label for="coverupload" class="flex flex-row items-center justify-start w-full p-2 border border-black outline-none cursor-pointer select-none hover:bg-gray-200 group">
                    <img src="{selected.ShopImage}" alt="Cover" class="h-12 mr-2">
                    <p class="font-bold group-hover:text-gray-800">Upload New Image</p>
                    <input id="coverupload" class="hidden" type="file" on:change={async e => selected.ShopImage = await imageupload(e)}>
                </label>
            </div>
            <div class="flex flex-col items-center justify-between">
                <p class="w-full text-left">Shop Logo</p>
                <label for="logoupload" class="flex flex-row items-center justify-start w-full p-2 border border-black outline-none cursor-pointer select-none hover:bg-gray-200 group">
                    <img src="{selected.ShopLogo}" alt="Logo" class="h-12 mr-2">
                    <p class="font-bold group-hover:text-gray-800">Upload New Image</p>
                    <input id="logoupload" class="hidden" type="file" on:change={async e => selected.ShopLogo = await imageupload(e)}>
                </label>
            </div>

            <button on:click={async () => {
                toast.push('Saving...', {
                    'classes': ['info']
                });
                await fetch('https://api.phoenix-pages.izmichael.com/shops/' + selected._id, {
                    headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8', 'Content-Type': 'application/json' },
                    method: 'PUT',
                    body: JSON.stringify(selected)
                });
                await sleep(1.1);
                refresh('shops');
                toast.push('Successfully saved your shop.', {
                    'classes': ['success']
                });
                selected = undefined;
            }} class="w-full col-span-2 p-1 font-bold text-white bg-green-500 hover:bg-green-400">Save</button>
        {:else}
            <img src="/assets/img/S2Dynmap.jpg" alt="Season 2 City" class="absolute z-10 object-cover h-full scale-30 botton-0" style="filter: brightness(50%);">
            <h1 class="z-20 w-full text-6xl font-semibold text-center text-white">No Shop Selected</h1>
        {/if}
    </div>
    <div class="flex flex-col items-center justify-start w-full h-full max-h-full gap-1 overflow-auto bg-gray-200 basis-1/3 grow shrink-0" bind:this={searchitems}>
        <div class="flex flex-col items-center justify-center w-full p-3 mb-2 bg-white cursor-pointer select-none" data-search="show">
            <h2 class="w-full text-lg font-light text-left">Search for a Shop</h2>
            <input bind:value={searchinp} on:keyup={() => search()} on:contextmenu|preventDefault={() => { searchinp = ''; search() }} class="w-full p-1 text-xl font-semibold text-left border-b border-gray-400 bg-inherit">
        </div>
        {#each api.shops.filter(shop => shop.ShopOwner.includes(api.player.PlayerUsername) || admin == true) as shop, i}
            <div class="flex flex-col items-center justify-center w-full p-3 bg-white cursor-pointer select-none hover:bg-gray-100" on:click={() => selected = shop}>
                <h2 class="w-full text-lg font-light text-left">{shop.ShopOwner}</h2>
                <h1 class="w-full text-xl font-semibold text-left">{shop.ShopName}</h1>
            </div>
        {:else}
            <p>Loading...</p>
        {/each}
    </div>
</div>

<style>
    #editor input {
        @apply w-full p-2 border border-black outline-none;
    }
</style>